import React from 'react'

export const PlusIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#fff"
        d="M9.005 18A9.06 9.06 0 0 0 18 8.995 9.066 9.066 0 0 0 8.995 0 9.058 9.058 0 0 0 0 8.995 9.067 9.067 0 0 0 9.005 18Zm0-1.605a7.365 7.365 0 0 1-7.391-7.4 7.367 7.367 0 0 1 7.38-7.4 7.39 7.39 0 0 1 7.408 7.4 7.368 7.368 0 0 1-7.397 7.4Zm-.02-3.231a.755.755 0 0 0 .77-.855V9.766h2.696a.752.752 0 0 0 .854-.752.753.753 0 0 0-.854-.78H9.755V5.543a.756.756 0 0 0-.77-.854.758.758 0 0 0-.762.854v2.693H5.54a.765.765 0 0 0-.864.78.764.764 0 0 0 .864.751h2.683v2.544a.758.758 0 0 0 .762.854Z"
      />
    </svg>
  )
}

export const CrossIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19 5 5 19M5 5l14 14"
      />
    </svg>
  )
}

export const UploadIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={18}
      viewBox="0 0 25 22"
      fill="none"
      {...props}
    >
      <path
        fill="#333945"
        d="M0 11.445c0-2.304 1.377-4.111 3.584-4.453.049-2.744 2.852-4.463 5.068-3.867C9.824 1.416 11.71 0 14.356 0c3.994 0 7.128 3.145 7.109 7.5 1.904.771 3.086 2.393 3.086 4.365 0 2.364-1.797 4.17-4.795 4.17h-6.66v-5.264l-.059-1.455.547.577 1.504 1.61a.733.733 0 0 0 .537.235c.4 0 .713-.293.713-.683 0-.215-.088-.371-.235-.518l-3.222-3.105c-.196-.196-.361-.254-.557-.254-.205 0-.37.058-.566.254l-3.223 3.105c-.146.147-.234.303-.234.518 0 .39.293.683.703.683a.72.72 0 0 0 .537-.234l1.514-1.611.547-.577-.059 1.455v5.264h1.553v4.248a.77.77 0 0 1-.772.752c-.42 0-.781-.342-.781-.752v-4.248H5.107c-3.203 0-5.107-2.05-5.107-4.59Z"
      />
    </svg>
  )
}

export const PaperClipIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#000"
        d="M8.94 20.74a5.85 5.85 0 0 1-4-1.56 5.228 5.228 0 0 1 0-7.68l7.56-7.14a4.22 4.22 0 0 1 5.69 0A4.101 4.101 0 0 1 19.5 7.3a3.46 3.46 0 0 1-1.1 2.55L10.83 17a2.47 2.47 0 0 1-3.36 0 2.23 2.23 0 0 1 0-3.28l7-6.59a.75.75 0 0 1 1.06 1.06l-7 6.59a.73.73 0 0 0 0 1.1 1 1 0 0 0 1.3 0l7.57-7.13A2.002 2.002 0 0 0 18 7.3a2.57 2.57 0 0 0-.84-1.84 2.67 2.67 0 0 0-3.63 0L6 12.59a3.73 3.73 0 0 0 0 5.5 4.4 4.4 0 0 0 6 0L19.49 11a.742.742 0 0 1 1.06 0 .75.75 0 0 1 0 1.06L13 19.18a5.84 5.84 0 0 1-4.06 1.56Z"
      />
    </svg>
  )
}

export const TrashIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="M10 11v6M14 11v6M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  )
}

export const ThreeDotsIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    viewBox="0 0 52 52"
    {...props}
  >
    <path fill="#CFD5D7" d="M8 20c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm18 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm18 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6z" />
  </svg>
  )
}

export const PrintIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
      <rect width={12} height={8} x={6} y={14} rx={1} />
    </svg>
  )
}

export const ChevronIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12.077}
      height={7.039}
      viewBox="0 0 12.077 7.039"
      {...props}
    >
      <path
        fill="none"
        stroke="#0085ff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m1.414 1.414 4.625 4.624 4.624-4.624"
        data-name="Path 1161"
      />
    </svg>
  )
}

export const LocationIcon = ({color = '#fff', ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 32 32"
      {...props}
    >
      <path fill={'currentColor'} d="M16.114-.011C9.555-.011 4 5.576 4 12.193c0 6.93 6.439 14.017 10.77 18.998.017.02.717.797 1.579.797h.076c.863 0 1.558-.777 1.575-.797 4.064-4.672 10-12.377 10-18.998C28 5.575 23.667-.011 16.114-.011zm.401 29.86a1.211 1.211 0 0 1-.131.107 1.218 1.218 0 0 1-.133-.107l-.523-.602c-4.106-4.71-9.729-11.161-9.729-17.055 0-5.532 4.632-10.205 10.114-10.205 6.829 0 9.886 5.125 9.886 10.205 0 4.474-3.192 10.416-9.485 17.657zm-.48-23.805a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm0 10c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.207 0 4 1.794 4 4 .001 2.206-1.747 4.044-3.954 4.044z" />
    </svg>
  )
}

export const CalendarIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="M16 14v2.2l1.6 1M16 2v4M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5M3 10h5M8 2v4" />
      <circle cx={16} cy={16} r={6} />
    </svg>
  )
}

export const MaintenanceIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z" />
    </svg>
  )
}

export const AttachmentIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox='0 0 24 24'
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      data-tsd-source="/src/routes/assets.maintenance.tsx:525:27"
      {...props}
    >
      <path d="m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551" />
    </svg>
  )
}

export const PhotoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox='0 0 24 24'
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      data-tsd-source="/src/routes/assets.maintenance.tsx:529:27"
      {...props}
    >
      <rect width={18} height={18} x={3} y={3} rx={2} ry={2} />
      <circle cx={9} cy={9} r={2} />
      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    </svg>
  )
}
